import React, { useRef } from "react";
import royal from "../assets/img/about/royal.jpg";
import propertyManagement from '../assets/img/newimgaes/Property management.jpeg'
import plumbing from '../assets/img/newimgaes/Plumbing.jpeg'
import mortgage from '../assets/img/newimgaes/Mortgage.jpeg'
import electrical from '../assets/img/newimgaes/Electrical.jpeg'
import doorPic from '../assets/img/newimgaes/Windows and Doors.jpeg'
import insurance from '../assets/img/newimgaes/Insurance.jpeg'
import interior from '../assets/img/newimgaes/interior.jpg'
import pLawers from '../assets/img/newimgaes/pLawer.jpg'
import willManage from '../assets/img/newimgaes/Will management.jpeg';
import { AddJobs } from "./global-components/AddJobs";
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/Property Services.jpeg';
import { Button, Typography } from "@mui/material";
export const Services = () => {
  const formRef = useRef(null);

 const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
    
    if (formRef.current && !('scrollBehavior' in document.documentElement.style)) {
      const elementPosition = formRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const sections = [
    {
      title: "Property Management",
      imgSrc: propertyManagement,
      description: `We have different property management options to our range of customers:
● Full maintenance with rent protection
● Rent collection
● Tenant find
● Property Inspections
● Tenant Sourcing & Screening
● Legal matters
● Evictions
● Buy-to-Let Advice`,
    },
    {
      title: "Interior Design",
      imgSrc: interior,
      description: `Royale Spaces offers expert interior design solutions tailored to transform any space into a stunning, functional masterpiece. Our dedicated interior team provides a wide range of services, including:
● Wardrobes
● Kitchen
● Media Units
● Studies & Office’s
● Beds & Other Home Furniture’s`,
    },
    {
      title: "Heating & Plumbing",
      imgSrc: plumbing,
      description: `Our professional plumbers ensure efficient and safe functioning of your systems.
Services include:
● General Plumbing & Heating Works
● Pipe / Tap leaks (Indoor / Outdoor) 
● Drain cleaning 
● Faucet or Shower Repairs / Replacement 
● Domestic Gas Works / Installations
● Boiler / Cylinder Servicing, Repairs & Installations
● Central Heating Conversions & Installations
● Bathroom Upgrades - We replace existing bathrooms, toilets, sinks & showers
`,
    },
    {
      title: "Electrical",
      imgSrc: electrical,
      description: `Our skilled electrical engineers provide comprehensive services, including:
● Wiring / Rewiring
● Lighting / Sockets / Switches - Installation / Repair
● EV charger installation
● Electrical fittings and appliances
● Electrical inspections
● Electrical certificates
● Smoke detectors
● Circuit breaker and fuse box services`,
    },
    {
      title: "Windows & Doors",
      imgSrc: doorPic,
      description: `Royale Spaces is an expert service provider for double-glazing doors and windows, offering a wide range of solutions, including:
● uPVC windows and doors 
● Aluminium windows and doors 
● Custom-sized bi-fold doors 
● Lift-and-slide aluminium doors (custom sizes)
● Integral blind systems for custom-sized windows and doors
`,
    },
    //     {
    //       title: "Locksmith",
    //       imgSrc: royal,
    //       description: `Our licensed locksmiths deliver tailored security solutions. Services include:
    // ● Lock installation / Repair
    // ● Re-keying (Changing internal mechanism of a lock)
    // ● Security upgrades (Installing high-security systems)
    // ● Emergency lockout assistance
    // ● Smart lock installation
    // ● Master key systems`,
    //     },
    {
      title: "Mortgage",
      imgSrc: mortgage,
      description: `Royale Spaces mortgage advisors guide clients through financing options for smooth home purchases:
● Mortgage orientation
● Loan application assistance
● Pre-approval and Pre-qualification
● Loan product advice
● Re-mortgage services
● Private mortgage insurance`,
    },
    {
      title: "Property Lawyers",
      imgSrc: pLawers,
      description: `Royale Spaces collaborates with expert property lawyers to provide comprehensive legal support for all real estate transactions. Our trusted legal partners offer a wide range of services, including:
● Property conveyancing for sales and purchases
● Lease drafting, review, and negotiations
● Title searches and ownership verification
● Property dispute resolution and mediation
● Commercial property transaction
● Landlord & Tenant Disputes
● Support for property development and planning permissions`,
    },
    {
      title: "Insurance",
      imgSrc: insurance,
      description: `We provide reliable and affordable insurance solutions to protect what matters most to you. Our experienced team is dedicated to personalized service, helping you navigate complexities to find the best policies for your lifestyle or business:
● Life insurance
● Health insurance
● Home insurance
● Business insurance
● Property and casualty insurance
● Travel insurance
● Others (please Specify)`,
    },
    {
      title: 'Will Management',
      imgSrc: willManage,
      description: `We understand the importance of securing your legacy and ensuring your wishes are honored. Our Will Management Services offer expert guidance in creating, organizing, and managing your will to give you peace of mind, knowing that your assets and loved ones are protected according to your wishes.
● Will drafting 
● Updating wills 
● Estate planning 
● Will storage 
● Probate assistance 
● Protective Property Trusts
● Lasting Power of Attorney`
    }
  ];

  return (
    <>
            <Pageheader headertitle="Property Management" bgImage={bgImage} subTitle={'India'}/>

      <div className="container mt-4">
        <div className="row">
          {/* Left side - Services sections */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Typography fontSize={16} className="mb-4">
              Royale Spaces offer a comprehensive range of real estate management services, including
            </Typography>
            <Button
              onClick={scrollToForm}
              variant="contained"
              size='large'
              sx={{
                backgroundColor: '#d8b035',
                color: '#fff',
                fontWeight: '600',
                '&:hover': {
                  backgroundColor: '#d8b035',
                  transform: 'scale(1.05)',
                  transition: 'all 0.3s ease',
                },
              }}
            >
              Post a Job
            </Button>
          </div>
          <div className="row">
            {sections.map((section, index) => (
              <div className="col-lg-4 mb-4" key={index}>
                <div className="service-section h-100" style={{
                  border: '1px solid #eee',
                  borderRadius: '8px',
                  padding: '20px',
                  backgroundColor: 'white',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s ease-out',
                }}>
                  <h3 style={{ fontSize: '1.5rem', marginBottom: '15px', color: '#10374A' }}>
                    {section.title}
                  </h3>
                  <div className="image-container" style={{
                    height: '200px',
                    overflow: 'hidden',
                    borderRadius: '5px',
                    marginBottom: '15px'
                  }}>
                    <img
                      src={section.imgSrc}
                      alt={section.title}
                      className="service-image"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.2s ease-out'
                      }}
                    />
                  </div>
                  <p style={{
                    whiteSpace: "pre-line",
                    fontSize: '14px',
                    lineHeight: '1.6',
                    color: '#666'
                  }}>
                    {section.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="row mt-5" ref={formRef}>
            <div className="col-lg-12 col-md-10 mx-auto">
              <div style={{
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                backgroundColor: 'white'
              }}>
                <AddJobs />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        // .service-section:hover {
        //   transform: translateY(-3px);
        //   box-shadow: 0 6px 12px rgba(0,0,0,0.1);
        // }
        // .service-section:hover .service-image {
        //   transform: scale(1.02);
        // }
         html {
    scroll-behavior: smooth;
  }
        @media (max-width: 991px) {
          .jobs-form {
            position: static;
            margin-top: 20px;
          }
        }
      `}</style>
    </>
  );
};
